import request from '@/api/request'


// 拼团分类
const fenleiApi = {
  getListPage: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpClass/getListPage',
      params,
      method: 'get'
    })
  },
  // 获取拼团活动分类表
  getActivitySpClass: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpClass/getActivitySpClass',
      data,
      method: 'post'
    })
  },
  // 添加拼团活动分类表
  addActivitySpClass: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpClass/addActivitySpClass',
      data,
      method: 'post'
    })
  },
  // 更新拼团活动分类表 
  updateActivitySpClass: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpClass/updateActivitySpClass',
      data,
      method: 'post'
    })
  }
}
//拼团订单
const order = {
  // 分页查询拼团订单 
  getListPage: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpOrder/getListPage',
      params,
      method: 'get'
    })
  },
  // 立即拼成
  updateGroupOrderById: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpRecord/updateGroupOrderById',
      params,
      method: 'get'
    })
  },
  //拼团活动订单-立即拼成
  updateGroupOrderById: (params) => {
    return request({
      url: 'activity/adm/activitySpRecord/updateGroupOrderById',
      params,
      method: 'get'
    })
  },
}

// 活动数据 
const data = {
  getDataListPage: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpellGroup/getDataListPage',
      params,
      method: 'get'
    })
  }
}

//拼团活动管理
const Admin = {
  //添加拼团活动
  addActivitySpellGroup: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpellGroup/addActivitySpellGroup',
      data,
      method: 'post'
    })
  },
  // 更新拼团活动启用状态 
  updateActivitySpellGroupState: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpellGroup/updateActivitySpellGroupState',
      data,
      method: 'post'
    })
  },
  // 活动列表 
  getListPage: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpellGroup/getListPage',
      params,
      method: 'get'
    })
  },
  //获取活动详情
  getActivitySpellGroup: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpellGroup/getActivitySpellGroup',
      data,
      method: 'post'
    })
  },
  // 更新活动数据 
  updateActivitySpellGroup: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpellGroup/updateActivitySpellGroup',
      data,
      method: 'post'
    })
  },
  //活动范围管理 
  fanweigetListPage: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpCompany/getListPage',
      params,
      method: 'get'
    })
  },
  //活动范围-更新 
  updateActivitySpCompany: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpCompany/updateActivitySpCompany',
      data,
      method: 'post',
      showToast: true
    })
  },
  // 产品管理弹框-添加 
  addActivitySpSku: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpSku/addActivitySpSku',
      data,
      method: 'post'
    })
  },
  //班级管理-列表 
  classgetListPage: (params) => {
    return request({
      url: 'admin/activity/adm/activitySpSku/getListPage',
      params,
      method: 'get'
    })
  },
  // 更新拼团活动班级/绑定分类 
  updateActivitySpSku: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpSku/updateActivitySpSku',
      data,
      method: 'post'
    })
  },
  //获取班级列表  
  getSkuList: (data) => {
    return request({
      url: 'admin/activity/adm/activitySpSku/getSkuList',
      data,
      method: 'post'
    })
  },
}

export {
  fenleiApi,
  order,
  data,
  Admin
}
